<div class="payments-toolbar-filters header-right">
  <div class="dropdown-container location-filter-wrapper">
    <button type="button" class="today-dropdown" (click)="toggleLocationDropdown($event)">
      <span>{{ selectedLocationLabel || 'All Locations' }}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [class.rotated]="isLocationDropdownOpen"
      >
        <path
          d="M5.28 7.38L10 12.1L14.72 7.38"
          stroke="#15172E"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="dropdown-menu" *ngIf="isLocationDropdownOpen" (click)="$event.stopPropagation()">
      <div class="dropdown-header">
        <span class="dropdown-title">Location</span>
      </div>
      <div class="dropdown-options">
        <div class="radio-option" (click)="selectLocation('')">
          <div class="radio-button" [class.selected]="!selectedLocationId">
            <div class="radio-inner" *ngIf="!selectedLocationId"></div>
          </div>
          <span class="radio-label" [class.selected]="!selectedLocationId">All Locations</span>
        </div>
        <div
          class="radio-option"
          *ngFor="let option of locationOptions"
          (click)="selectLocation(option.value)"
        >
          <div class="radio-button" [class.selected]="selectedLocationId === option.value">
            <div class="radio-inner" *ngIf="selectedLocationId === option.value"></div>
          </div>
          <span class="radio-label" [class.selected]="selectedLocationId === option.value">{{
            option.label
          }}</span>
        </div>
        <div class="radio-option" *ngIf="!locationOptions.length">
          <div class="radio-button selected">
            <div class="radio-inner"></div>
          </div>
          <span class="radio-label selected">No Location</span>
        </div>
      </div>
    </div>
  </div>

  <div class="dropdown-container date-filter-wrap period-dropdown-wrapper" *ngIf="showPeriodFilter">
    <button type="button" class="today-dropdown" (click)="togglePeriodDropdown($event)">
      <span>{{ selectedPeriodLabel }}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [class.rotated]="isPeriodDropdownOpen"
      >
        <path
          d="M5.28 7.38L10 12.1L14.72 7.38"
          stroke="#15172E"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <app-date-range-picker
      [isOpen]="isPeriodDropdownOpen"
      [selectedPeriod]="selectedPeriod"
      [customDateRange]="customDateRange"
      [periodOptions]="periodOptions"
      (close)="closePeriodDropdown()"
      (apply)="onDateRangeApply($event)"
    >
    </app-date-range-picker>
  </div>

  <div class="dropdown-container status-filter-wrapper" *ngIf="showStatusFilter">
    <button type="button" class="today-dropdown" (click)="toggleStatusDropdown($event)">
      <span>Status</span>
      <span class="status-count" *ngIf="selectedStatuses.length">{{
        selectedStatuses.length
      }}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [class.rotated]="isStatusDropdownOpen"
      >
        <path
          d="M5.28 7.38L10 12.1L14.72 7.38"
          stroke="#15172E"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div
      class="dropdown-menu status-dropdown-menu"
      *ngIf="isStatusDropdownOpen"
      (click)="$event.stopPropagation()"
    >
      <div class="dropdown-header">
        <span class="dropdown-title">Status</span>
      </div>
      <div class="dropdown-options">
        <label class="status-option" *ngFor="let item of statusOptions">
          <input
            type="checkbox"
            [id]="statusSelectInputId + '-' + item.value"
            [checked]="draftSelectedStatuses.includes(item.value)"
            (change)="onDraftStatusToggle(item.value, $any($event.target).checked)"
          />
          <span class="status-option-label">{{ item.label }}</span>
        </label>
      </div>
      <app-modal-footer-actions
        footerClass="modal-footer--compact"
        [primaryDisabled]="primaryDisabled"
        (secondaryClick)="onStatusClear()"
        (cancelClick)="onStatusCancel()"
        (primaryClick)="onStatusApply()"
      />
    </div>
  </div>

  <button
    *ngIf="showExportButton"
    type="button"
    class="today-dropdown export-btn"
    [disabled]="exportLoading"
    (click)="exportClick.emit()"
  >
    <span>Export</span>
    <span class="export-spinner" *ngIf="exportLoading">...</span>
  </button>
</div>
